/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_ManagerInputs */

const en_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manager`)
};

const fr_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manager`)
};

const de_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manager`)
};

const it_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manager`)
};

const ru_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер`)
};

const es_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente`)
};

const zh_cn2_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经理`)
};

const ja_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マネージャー`)
};

const hi_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रबंधक`)
};

const pt_pt2_team_manager_role_manager = /** @type {(inputs: Team_Manager_Role_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente`)
};

/**
* | output |
* | --- |
* | "Manager" |
*
* @param {Team_Manager_Role_ManagerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_manager = /** @type {((inputs?: Team_Manager_Role_ManagerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_ManagerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_role_manager(inputs)
	if (locale === "de") return de_team_manager_role_manager(inputs)
	if (locale === "it") return it_team_manager_role_manager(inputs)
	if (locale === "ru") return ru_team_manager_role_manager(inputs)
	if (locale === "es") return es_team_manager_role_manager(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_role_manager(inputs)
	if (locale === "ja") return ja_team_manager_role_manager(inputs)
	if (locale === "hi") return hi_team_manager_role_manager(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_role_manager(inputs)
	return en_team_manager_role_manager(inputs)
});